<app-alert></app-alert>

<p-card styleClass="w-100 mt-2">
  <div class="customizer" [formGroup]="configRegistrationForm">
    <div class="p-fluid p-formgrid row">
      <div class="p-field col-lg-4 col-sm-4 col-md-12 col-12">
        <label class="intake-form-labels" for="datetimeFormat"
          >Date & Time Format
          <span class="requiredfield text-danger">*</span>
        </label>
        <p-dropdown
          styleClass="w-100"
          [options]="datetimeFomatList"
          placeholder="Select Date & Time Format"
          id="datetimeFormat"
          optionLabel="lookupvalue"
          optionValue="lookupkey"
          formControlName="datetimeformat">
        </p-dropdown>
        <div
          *ngIf="
            tabErrorShow
              ? configRegistrationForm.controls['datetimeformat'].invalid
              : configRegistrationForm.controls['datetimeformat'].errors &&
                configRegistrationForm.controls['datetimeformat'].touched
          ">
          <div class="p-error block mt-1">Date & Time Format is required </div>
        </div>
      </div>
      <div class="p-field col-lg-4 col-sm-4 col-md-12 col-12">
        <label class="intake-form-labels" for="timezone"
          >Time Zone
          <span class="requiredfield text-danger">*</span>
        </label>
        <p-dropdown
          styleClass="w-100"
          [options]="timezoneList"
          placeholder="Select Time Zone"
          id="timezone"
          optionLabel="lookupvalue"
          optionValue="lookupvalue"
          formControlName="timezone">
        </p-dropdown>
        <div
          *ngIf="
            tabErrorShow
              ? configRegistrationForm.controls['timezone'].invalid
              : configRegistrationForm.controls['timezone'].errors &&
                configRegistrationForm.controls['timezone'].touched
          ">
          <div class="p-error block mt-1">Timezone is required </div>
        </div>
      </div>
    </div>
  </div>

  <div class="text-md-right mt-2">
    <button
      type="button"
      class="btn bg-white text-primary btncancel"
      *ngIf="configRegistrationForm.invalid"
      (click)="getConfigById()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary" (click)="saveConfig()">
      {{ updateButton ? 'Update' : 'Submit' }}
    </button>
  </div>
</p-card>
